interface ChevronRightIconProps {
  className?: string;
}

const ChevronRightIcon = ({ className = '' }: ChevronRightIconProps) => (
  <svg
    width='16'
    height='16'
    className={className}
    fill='none'
    viewBox='0 0 24 24'
  >
    <path
      d='M9 18l6-6-6-6'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ChevronRightIcon;
